var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongHuifuquanbu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15 13.06c-1.414-1.838-2.756-2.382-3.32-2.572-1.187-.402-2.21-.408-3.201-.235v3.325L3.593 8.393 8.479 3l-.012 3.111c1.834.016 3.422.726 4.459 1.763 1.037 1.037 1.877 3.119 2.074 5.185z",
    stroke: "#3F465C",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.597 3.32L1 8.392l4.608 4.89",
    stroke: "#3F465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_huifuquanbu.b4817d3f.svg";
export { SvgTongyongHuifuquanbu as ReactComponent };